import { ColoursObj } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { cardTranslation } from "i18n/translateHelpers";
import { useFormatValue } from "../../hooks/useFormatValue";
import { CardText } from "../subComponents/cardText";
import { RowInfoStandart } from "../subComponents/RowInfoStandart";
interface IHotelCheckInTimesProps {
  checkInTime?: string;
  checkOutTime?: string;
}

export const HotelCheckInTimes = ({ checkInTime, checkOutTime }: IHotelCheckInTimesProps) => {
  const { formatValue } = useFormatValue();
  return (
    <Stack spacing="8px" sx={{
      paddingBottom: "8px"
    }}>
      <CardText variant="bodyBold">{cardTranslation("Check-in & Check-out")}</CardText>
      {checkInTime && (
        <RowInfoStandart
          icon="Right"
          bubbleColour={ColoursObj.core.secondary}
          middle={cardTranslation("Check-in")}
          end={formatValue(checkInTime, "datetime")}
        />
      )}
      {checkOutTime && (
        <RowInfoStandart
          icon="Left"
          bubbleColour={ColoursObj.core.secondary}
          middle={cardTranslation("Check-out")}
          end={formatValue(checkOutTime, "datetime")}
        />
      )}
    </Stack>
  );
};
